// Shared navigation for pages using the original theme layout.
(() => {
 function init(){
  document.querySelectorAll('.rwc-global .rwc-menu-toggle').forEach(button=>{
   if(button.dataset.ready)return;button.dataset.ready='1';
   const nav=document.getElementById(button.getAttribute('aria-controls'));
   const set=open=>{button.setAttribute('aria-expanded',String(open));nav?.classList.toggle('is-open',open)};
   button.addEventListener('click',()=>set(button.getAttribute('aria-expanded')!=='true'));
   nav?.addEventListener('click',event=>{if(event.target.closest('a'))set(false)});
   [button,nav].filter(Boolean).forEach(el=>el.addEventListener('keydown',event=>{if(event.key==='Escape'){set(false);button.focus()}}));
  });
  // Original-layout pages use the cart page, rather than the Cinnamon drawer.
  document.querySelectorAll('.rwc-global [data-rwc-cart-open]').forEach(link=>{link.removeAttribute('aria-haspopup');link.removeAttribute('aria-controls')});
  document.querySelectorAll('.rwc-global [data-rwc-countdown]').forEach(el=>{
   if(el.dataset.ready)return;el.dataset.ready='1';
   const duration=Number(el.dataset.duration)*1000;if(!(duration>0))return;
   const repeat=el.dataset.repeat!=='false',key='rwc-countdown-'+duration;let start=Date.now();
   try{const saved=Number(localStorage.getItem(key));if(saved>0&&saved<=start)start=saved}catch(e){}
   if(repeat&&Date.now()-start>=duration)start=Date.now()-((Date.now()-start)%duration);
   try{localStorage.setItem(key,String(start))}catch(e){}
   function tick(){let left=start+duration-Date.now();if(left<=0&&repeat){start=Date.now();left=duration;try{localStorage.setItem(key,String(start))}catch(e){}}
    const seconds=Math.max(0,Math.ceil(left/1000));
    [['hours',Math.floor(seconds/3600)],['minutes',Math.floor(seconds%3600/60)],['seconds',seconds%60]].forEach(([key,value])=>{const node=el.querySelector('[data-'+key+']');if(node)node.textContent=String(value).padStart(2,'0')});
    if(seconds>0||repeat)setTimeout(tick,1000);
   }tick();
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();
